angular.module("ainapp")
    .controller("vacationSettingsController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Vacation Settings";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.Init = function () {

                $scope.SeectedGradeId = 0;
                $scope.Grades = [];
                $scope.Components = [];
                $scope.Settings = [];

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                MainService.PayrollComponentsByType("Earnings").then(function (response) {
                    if (response.data) {
                        $scope.Components = response.data;

                        $.LoadingOverlay("show", {
                            image: "images/load.gif",
                        });

                        angular.forEach($scope.Components, function (a) {
                            var temp = {
                                GradeId: null,
                                PayrollComponentId: a.Id,
                                PayrollComponent: a,
                                AmountPercentage: 100,
                                EncashPercentage: 100,
                                ExcessPercentage: 100,
                                IgnoreAmount: false,
                                IgnoreEncash: false,
                                IgnoreExcess: false,
                            }
                            $scope.Settings.push(temp);
                        })

                        MainService.VacationSettingsByGradeId(0).then(function (response) {
                            if (response.data) {

                                if (response.data.length > 0) {
                                    angular.forEach($scope.Settings, function (e) {

                                        angular.forEach(response.data, function (a) {

                                            if (e.PayrollComponentId == a.PayrollComponentId) {
                                                e.AmountPercentage = a.AmountPercentage;
                                                e.EncashPercentage = a.EncashPercentage;
                                                e.ExcessPercentage = a.ExcessPercentage;
                                                e.IgnoreAmount = a.IgnoreAmount;
                                                e.IgnoreEncash = a.IgnoreEncash;
                                                e.IgnoreExcess = a.IgnoreExcess;
                                                e.Id = a.Id;
                                            }
                                        })

                                    })
                                }
                            }
                            $.LoadingOverlay("hide");
                        }, function (err) {
                            toastr.error("Network Error");
                            $.LoadingOverlay("hide");
                        })

                        $.LoadingOverlay("hide");
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $.LoadingOverlay("hide");
                })

                MainService.GradesInDropdown().then(function (response) {
                    if (response.data) {
                        $scope.Grades = response.data;
                        var tt = {
                            Id: 0,
                            Name: "All"
                        }
                        $scope.Grades.unshift(tt);
                        $.LoadingOverlay("hide");
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $.LoadingOverlay("hide");
                })

            }
            $scope.Init();


            $scope.changeGrade = function (data) {

                $scope.SeectedGradeId = data.Id;
                $scope.SeectedGrade = data;
                $scope.Settings = [];

                angular.forEach($scope.Components, function (a) {
                    var temp = {
                        GradeId: data.Id,
                        PayrollComponentId: a.Id,
                        PayrollComponent: a,
                        AmountPercentage: 100,
                        EncashPercentage: 100,
                        ExcessPercentage: 100,
                        IgnoreAmount: false,
                        IgnoreEncash: false,
                        IgnoreExcess: false,
                    }
                    $scope.Settings.push(temp);
                })

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                MainService.VacationSettingsByGradeId(data.Id).then(function (response) {
                    if (response.data) {

                        if (response.data.length > 0) {
                            angular.forEach($scope.Settings, function (e) {

                                angular.forEach(response.data, function (a) {

                                    if (e.PayrollComponentId == a.PayrollComponentId) {
                                        e.AmountPercentage = a.AmountPercentage;
                                        e.EncashPercentage = a.EncashPercentage;
                                        e.ExcessPercentage = a.ExcessPercentage;
                                        e.IgnoreAmount = a.IgnoreAmount;
                                        e.IgnoreEncash = a.IgnoreEncash;
                                        e.IgnoreExcess = a.IgnoreExcess;
                                        e.Id = a.Id;
                                    }
                                })

                            })
                        }
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $.LoadingOverlay("hide");
                })


            }


            $scope.save = function () {

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.AddVacationSettings($scope.Settings).then(function (response) {
                    if (response.data) {
                        toastr.success("Success");

                        if ($scope.SeectedGradeId > 0) {
                            $scope.changeGrade($scope.SeectedGrade);
                        } else {
                            $scope.Init();
                        }

                    } else {
                        toastr.error("Network Error");
                    }
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }




    }]);
